var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "emd-flex-grow_1 emd-flex-shrink_1 emd-flex emd-overflow_hidden",
    },
    [
      _c(
        "div",
        {
          staticClass:
            "emd-container__content emd-flex emd-justify_space-between emd-overflow_hidden",
        },
        [
          _c(
            "form",
            {
              attrs: { id: "form-check-user-for-invite" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.checkUserForInviteEmployee.apply(null, arguments)
                },
              },
            },
            [
              _vm.isLoading
                ? _c(
                    "div",
                    { staticClass: "eu-pa_6 eu-align_center" },
                    [_c("emd-loader", { attrs: { type: "_invert" } })],
                    1
                  )
                : _c(
                    "div",
                    {
                      staticClass: "emd-form-group",
                      class: { _state_error: _vm.fields.email.hasError },
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "emd-label",
                          attrs: { for: "invite-email" },
                        },
                        [_vm._v(_vm._s(_vm.$t("email")))]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.email.value,
                            expression: "fields.email.value",
                          },
                        ],
                        staticClass: "emd-input",
                        attrs: { type: "email", id: "invite-email" },
                        domProps: { value: _vm.fields.email.value },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.fields.email,
                                "value",
                                $event.target.value
                              )
                            },
                            function ($event) {
                              return _vm.emailValidation()
                            },
                          ],
                        },
                      }),
                      _vm._l(_vm.fields.email.errors, function (error, key) {
                        return _c(
                          "p",
                          { key: key, staticClass: "emd-input-feedback" },
                          [_vm._v(" " + _vm._s(error) + " ")]
                        )
                      }),
                    ],
                    2
                  ),
            ]
          ),
        ]
      ),
      !_vm.isLoading
        ? _c("div", { staticClass: "emd-container__footer emd-ta_right" }, [
            _c(
              "button",
              {
                staticClass: "emd-btn _color_primary _type_text eu-mr_2",
                attrs: { type: "button" },
                on: { click: _vm.hideCancelled },
              },
              [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
            ),
            _c(
              "button",
              {
                staticClass: "emd-btn _color_primary",
                class: { _disabled: _vm.fields.email.hasError },
                attrs: { form: "form-check-user-for-invite", type: "submit" },
              },
              [_vm._v(" " + _vm._s(_vm.$t("continue")) + " ")]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }